import { render, staticRenderFns } from "./Tecnologia.vue?vue&type=template&id=6f7bb832&scoped=true&"
import script from "./Tecnologia.vue?vue&type=script&lang=js&"
export * from "./Tecnologia.vue?vue&type=script&lang=js&"
import style0 from "./Tecnologia.vue?vue&type=style&index=0&id=6f7bb832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7bb832",
  null
  
)

export default component.exports